import {
    Box,
    Button,
    ButtonGroup,
    Flex,
    Heading,
    Menu,
    MenuButton,
    MenuDivider,
    MenuItem,
    MenuList,
    Spacer,
    Text
} from '@chakra-ui/react'
import React from 'react'
import {useMatch, useNavigate} from 'react-router-dom'
import {navigationRoutes} from '../../../router'
import {useAuth} from '../../../auth'
import {BrandLogo} from "../../../assets";
import { BRAND_NAME } from "../../../config/branding";
import getPrettyUserRole from "../../../helpers/userRole";
import { WCR_COMPANY_ABBREVIATIONS } from '../../../constants'

const NavigationLink = ({path, label}) => {
    const isMatching = useMatch(`${path}/*`)
    const navigate = useNavigate()


    return (
        <Button
            color="gray.500"
            isActive={isMatching}
            _hover={{
                color: 'gray.600',
                textDecoration: 'underline',
                textDecorationColor: 'brand.300',
                textDecorationThickness: '3px'
            }}
            _active={{
                color: 'black',
                textDecoration: 'underline',
                textDecorationColor: 'accent.400',
                textDecorationThickness: '3px'
            }}
            onClick={() => navigate(path)}
        >
            {label}
        </Button>
    )
}

const Navigation = () => {
    const {user} = useAuth()
    return (
        <ButtonGroup variant="link" spacing={4}>
            {navigationRoutes[user.role].map((navLink) => {
                return (
                    <NavigationLink
                        key={navLink.path}
                        path={navLink.path}
                        label={navLink.label}
                    />
                )
            })}
        </ButtonGroup>
    )
}


const UserViewButton = () => {
    const { user, logout } = useAuth();

    const hasUserInfo = (
        (user?.company && WCR_COMPANY_ABBREVIATIONS[user.company]) ||
        user?.category ||
        user?.pointOfWork
    );

    return (
        <Menu>
            <MenuButton
                as={Button}
                variant="outline"
                colorScheme="brand"
                _hover={{ bg: 'brand.100' }}
                _active={{ bg: 'brand.200' }}
                rightIcon={<i className="far fa-bars" />}
            >
                <Flex direction="column" align="center">
                    {user?.username && (
                        <Text fontSize="sm" fontWeight="bold">
                            {user.username}
                        </Text>
                    )}
                    {user?.role && (
                        <Text fontSize={["xs", "sm"]} color="gray.500">
                            Rol: {getPrettyUserRole(user.role)}
                        </Text>
                    )}
                </Flex>
            </MenuButton>
            <MenuList>
                {hasUserInfo && (
                    <>
                        <Box px={4} py={3}>
                            {user?.company && WCR_COMPANY_ABBREVIATIONS[user.company] && (
                                <Text fontSize="sm" color="gray.600">
                                    Companie: {WCR_COMPANY_ABBREVIATIONS[user.company].name}
                                </Text>
                            )}
                            {user?.category && (
                                <Text fontSize="sm" color="gray.600">
                                    Categorie: {user.category}
                                </Text>
                            )}
                            {user?.pointOfWork && (
                                <Text fontSize="sm" color="gray.600">
                                    Punct de lucru: {user.pointOfWork}
                                </Text>
                            )}
                        </Box>
                        <MenuDivider />
                    </>
                )}
                <MenuItem icon={<i className="far fa-sign-out" />} onClick={logout}>
                    Deconectează-te
                </MenuItem>
            </MenuList>
        </Menu>
    );
};


const TopBar = () => {
    return (
        <Flex
            w="100%"
            borderBottom="1px"
            borderColor="gray.200"
            p="4"
            align="center"
        >
            <Box mr="5">
                <Heading size="lg">
                    <img width="120" src={BrandLogo} alt={`${BRAND_NAME} Logo`}/>
                </Heading>
            </Box>
            <Navigation/>
            <Spacer/>

            <UserViewButton/>
        </Flex>
    )
}

export default TopBar
